export default "__VITE_ASSET__0a93dc45__"